const IMAGE_URL_DIMENSIONS_REGEX = new RegExp("/rs:(?<resizingType>[^:]+):(?<width>[0-9]+):(?<height>[0-9]+):(?<enlarge>[0-9]+)/")

const decodeImageUrl = (url) => {
  const addr = new URL(url)

  const path = addr.pathname

  const matchResult = path.match(IMAGE_URL_DIMENSIONS_REGEX)

  return matchResult.groups
}

const dimensionsFromImageUrl = (url) => {
  const {width, height, resizingType} = decodeImageUrl(url)

  if (resizingType === 'fill') {
    return {
      width,
      height
    }
  } else {
    return {}
  }
}

export {
  decodeImageUrl,
  dimensionsFromImageUrl
}
